<app-aggregate [size]="size" [stacked]="stacked" [compact]="compact" [hasShadow]="hasShadow" [title]="title"
    [value]="value" [valueColor]="color" [decimals]="currency ? currency.decimal_points : 2"
    [symbol]="currency ? currency.symbol: ''">
</app-aggregate>